import qribft from "@/assets/qr_IBFT.json";
import qr_mrcht_acc_info from "@/assets/qr_mrcht_acc_info_tmp.json";
import qribft_subtab from "@/assets/qr_ibft_subtab.json"

export default class InvIBFTs {
    jArray = [];
    
    jsonToArray(jsonData){
        this.jArray.push(jsonData);
    }

    showData(){
        // ID + 길이 + Value
        console.log(JSON.stringify(this.jArray));
        var qrStr = "";
        for(var elem in this.jArray){
            var len = "";
            for(var elem2 in qribft){
                if(elem2 == "MerchantAccInfo"){
                    elem2 = "ConsumerAccInfo"; // 예외적인 상황이라 체크할 것
                }
                if(this.jArray[elem][elem2] != undefined && (this.jArray[elem][elem2].Value != "" && this.jArray[elem][elem2].Value != undefined)){
                    if((this.jArray[elem][elem2].Value).length < 10){
                        len = "0" + (this.jArray[elem][elem2].Value).length;
                    } else {
                        len = len + (this.jArray[elem][elem2].Value).length;
                    }
                    // 38인 경우는 Depth가 더 들어가서 구성하기 떄문에 그 외인 경우에 대해서만 QR String 만들기 
                    if(this.jArray[elem][elem2].ID != "38"){
                        qrStr += (this.jArray[elem][elem2].ID +""+ len +""+ this.jArray[elem][elem2].Value);
                    }
                    // ID -> 38 Depth 1로 들어가기
                    // ID = 38일때 ID값과 길이를 가져와서 앞에 붙여주기
                    else {
                        var id1 = this.jArray[elem][elem2].ID;
                        var len1 =  (this.jArray[elem][elem2].Value).length;
                        len = ""; // 초기화 
                        for(var elem3 in qr_mrcht_acc_info){
                            if(this.jArray[elem][elem3] != undefined && (this.jArray[elem][elem3].Value != "" && this.jArray[elem][elem3].Value != undefined)){
                                if((this.jArray[elem][elem3].Value).length < 10){
                                    len = "0" + (this.jArray[elem][elem3].Value).length;
                                } else {
                                    len = (this.jArray[elem][elem3].Value).length;
                                }
            
                                // ID가 01인 경우 Depth 2에서 QR String 구성
                                // ID가 00인 경우 (처음 - Mandatory) ID랑 Length 넣어주기

                                if(this.jArray[elem][elem3].ID != "01"){
                                    if(this.jArray[elem][elem3].ID == "00"){
                                        qrStr += id1 +""+ len1 + "" + (this.jArray[elem][elem3].ID +""+len+""+this.jArray[elem][elem3].Value);
                                    } else {
                                        qrStr += (this.jArray[elem][elem3].ID +""+len+""+this.jArray[elem][elem3].Value);
                                    }

                                    id1 = "";
                                    len1 = "";
                                }
                                // ID가 01인 경우 Depth2로 들어가서 QR String 구성
                                else {
                                    var id2 = this.jArray[elem][elem3].ID;
                                    var len2 = (this.jArray[elem][elem3].Value).length;
                                    len = "";
                                    for(var elem4 in qribft_subtab){
                                        if(this.jArray[elem][elem4] != undefined && (this.jArray[elem][elem4].Value != "" && this.jArray[elem][elem4].Value != undefined)){
                                          if((this.jArray[elem][elem4].Value).length < 10){
                                              len = "0" + (this.jArray[elem][elem4].Value).length;
                                          } else {
                                              len = (this.jArray[elem][elem4].Value).length;
                                          }
                                          // 처음 ID 값에 대해서만 이전 38인 경우 아이디와 길이만 넣어주면 됨
                                          // depth가 2인 경우가 가장 마지막 분할이기 때문에 더 분할로 테이블을 들어가진 않는다.
                                          if(this.jArray[elem][elem4].ID == "00"){
                                            qrStr += id2 +""+ len2 + "" + (this.jArray[elem][elem4].ID +""+len+""+this.jArray[elem][elem4].Value);
                                          }
                                          else {
                                            qrStr += (this.jArray[elem][elem4].ID +""+len+""+this.jArray[elem][elem4].Value);
                                          }
                                        }
                                        len = "";
                                    }
                                    console.log("elem4 qrStr : " + qrStr);
                                }
                            }
                            len = ""; // 초기화 
                        }
                        console.log("elem3 qrStr : " + qrStr);
                    }
                }
                len = ""; // 초기화
            }
            console.log("elem2 qrStr : " + qrStr);
            len = "";
        }
        
        return qrStr;
    }
}